import React from 'react';

class Notification extends React.Component {
  
    componentDidMount(){
      setTimeout(() => {
          this.props.setNotification('')
      }, 4000);
    }

    render(){
        let notificationType = '';
        switch (this.props.intent) {
            case 'e':
                notificationType = 'notification alert';
                break;

            case 'm':
                notificationType = 'notification success';
                break;

            case 'w':
                notificationType = 'notification warning';
                break;
        
            default:
                notificationType = 'notification alert';
                break;
        }
        return (<div className={notificationType}>{this.props.message}</div>)
    }
}

export default Notification;